"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collaboration = void 0;
const index_1 = require("./Base/index");
/**
 * Contains information about the BPMN collaboration, such as the name of the
 * collaboration and a list of participants.
 */
class Collaboration extends index_1.BaseElement {
    constructor() {
        super(...arguments);
        this.participants = [];
        this.messageFlows = [];
    }
}
exports.Collaboration = Collaboration;
//# sourceMappingURL=Collaboration.js.map